<template>
  <v-layout style="gap: 10px">
    <v-flex xs12 md8>
      <base-card :title="$t('overviewReport.overview')" class="grow-1">
        <template slot="content">
          <BarChart :chart-data="barchartData"/>
        </template>
      </base-card>
    </v-flex>
    <v-flex xs12 md4>
      <base-card :title="$t('overviewReport.agentStatus')" class="grow-2">
        <template slot="content">
          <DoughnutChart :chart-data="pieChartData"/>
        </template>
      </base-card>
    </v-flex>
  </v-layout>
</template>

<script>
import BaseCard from "components/BaseCard";
import BarChart from "components/charts/BarChart";
import DoughnutChart from "components/charts/DoughnutChart";
import {mapState} from "vuex";

export default {
  name: "OverviewReportDashboard",
  components: {DoughnutChart, BarChart, BaseCard},
  computed: {
    ...mapState('overviewReport', ['overviewReport', 'autoAssignStatusManage', 'filter']),
    barchartData() {
      const labels = [
          'SLA 10s',
          'SLA 30s',
          'SLA 40s',
          'SLA 1m',
          'SLA 5m',
          'SLA after 5m'
      ];
      let data = []
      if (this.overviewReport) {
        const totalSession = this.overviewReport.total_chat,
            sla10s = totalSession > 0 ? (this.overviewReport.earlier_ten_seconds / totalSession) * 100 : 0,
            sla30s = totalSession > 0 ? (this.overviewReport.earlier_thirty_seconds / totalSession) * 100 : 0,
            sla40s = totalSession > 0 ? (this.overviewReport.earlier_forty_five_seconds / totalSession) * 100 : 0,
            sla1m = totalSession > 0 ? (this.overviewReport.earlier_one_minute / totalSession) * 100 : 0,
            sla5m = totalSession > 0 ? (this.overviewReport.earlier_five_minute / totalSession) * 100 : 0,
            after5m = totalSession - this.overviewReport.earlier_five_minute,
            slaAfter5m = totalSession > 0 ? (after5m / totalSession) * 100 : 0;
            data = [sla10s.toFixed(), sla30s.toFixed(), sla40s.toFixed(), sla1m.toFixed(), sla5m.toFixed(), slaAfter5m.toFixed()];
      }
      return {
        labels,
        datasets: [
          {
            label: 'SLA',
            backgroundColor: '#3d5b96',
            data
          }
        ],
      }
    },
    pieChartData() {
      const labels = [
          'Agent Active',
          'Agent DeActive'
      ];
      let countAgentActivate = 0;
      let countAgentDeactivate = 0;
      if (this.autoAssignStatusManage) {
        let isEnableAutoAssign = this.autoAssignStatusManage.enable_auto_assign;
        let supporters = this.autoAssignStatusManage.supporters;
        if (isEnableAutoAssign === "0") {
          countAgentActivate = 0;
          countAgentDeactivate = supporters.length;
        }
        else {
          countAgentActivate = supporters.filter(supporter => {
            return supporter.auto_assign_config.active && this.filter.skills.every(v => supporter.auto_assign_config.request_support_categories.includes(v));
          }).length;
          countAgentDeactivate = supporters.length - countAgentActivate
        }
      }
      return {
        labels,
        datasets: [
          {
            backgroundColor: [
              'green'
            ],
            data: [
              countAgentActivate, countAgentDeactivate
            ]
          }
        ]
      }
    }
  },
}
</script>

<style scoped lang="scss">
</style>